import React, { useState } from 'react';
import { FaCopy } from 'react-icons/fa';

interface ButtonCopyProps {
  selected?: boolean;
  onClick?: () => void;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const ButtonCopy: React.FC<ButtonCopyProps> = ({
  selected,
  onClick,
  title,
  style,
  className,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      type="button"
      title={title || 'Αντιγραφή'}
      onClick={onClick}
      className={
        `btn btn-sm  ` +
        (selected ? 'btn-warning' : 'btn-outline-primary') +
        (className ? ` ${className}` : '')
      }
      style={{
        borderRadius: '50%',
        width: 26,
        height: 26,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        fontWeight: 600,
        background: selected ? '#ff9800' : undefined,
        color: hovered ? '#1976d2' : selected ? '#fff' : undefined,
        border: selected ? '1px solid #ff9800' : undefined,
        boxShadow: selected ? '0 2px 8px rgba(255,152,0,0.15)' : undefined,
        transition: 'all 0.18s cubic-bezier(.4,0,.2,1)',
        transform: hovered ? 'scale(1.08)' : 'scale(1)',
        ...style,
      }}
      onMouseEnter={(e) => {
        setHovered(true);
        if (!selected) {
          (e.currentTarget as HTMLButtonElement).style.background = '#ff9800';
          (e.currentTarget as HTMLButtonElement).style.color = '#1976d2';
          (e.currentTarget as HTMLButtonElement).style.border = '1px solid #ff9800';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 2px 8px rgba(255,152,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        setHovered(false);
        if (!selected) {
          (e.currentTarget as HTMLButtonElement).style.background = '';
          (e.currentTarget as HTMLButtonElement).style.color = '';
          (e.currentTarget as HTMLButtonElement).style.border = '';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = '';
        }
      }}
      onMouseDown={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(0.95)';
      }}
      onMouseUp={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = hovered
          ? 'scale(1.08)'
          : 'scale(1)';
      }}
    >
      <FaCopy style={{ fontSize: '0.9em' }} />
    </button>
  );
};

export default ButtonCopy;

